import {Component, OnInit} from '@angular/core';
import {Artwork} from "../../../models/artwork";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {ArtworkService} from "../../../services/artwork/artwork.service";
import {combineLatest} from "rxjs";
import {CustomValidators} from "../../../calsses/CustomValidators";
import {Category} from "../../../models/category";
import {CategoryService} from "../../../services/category/category.service";
import {MessagesService} from "../../../services/messages/messages.service";

@Component({
    selector: 'app-edit-category',
    templateUrl: './edit-category.component.html',
    styleUrls: ['./edit-category.component.scss']
})
export class EditCategoryComponent implements OnInit {

    category: Category;
    projectId: string;
    databaseId: string;
    categoryId: string;

    categoryForm: FormGroup;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private formBuilder: FormBuilder,
        private categoryService: CategoryService,
        private messagesService: MessagesService
    ) {
    }

    ngOnInit() {
        combineLatest(
            this.route.parent.params,
            this.route.params
        ).subscribe(
            params => {
                this.projectId = params[0]['project_id'];
                this.databaseId = params[0]['database_id'];
                this.categoryId = params[1]['category_id'];

                this.categoryForm = this.formBuilder.group({
                    name: ['', [Validators.required]],
                    preferred: [''],
                });

                this.categoryService.getSingleCategory(this.projectId, this.databaseId, this.categoryId)
                    .subscribe(
                        () => this.category = this.categoryService.category,
                        err => this.messagesService.errorToast(err),
                        () => this.categoryForm.patchValue({...this.category.getObj(), database_id: this.databaseId})
                    )
            },
            err => this.messagesService.errorToast(err),
        );
    }

    onSubmit() {
        const payload = new Category(this.categoryForm.getRawValue());

        this.categoryService.patchCategory(this.projectId, this.databaseId, this.categoryId, payload)
            .subscribe(
                () => {
                    this.messagesService.successToast('Category updated.');
                    this.router.navigate(['/projects/' + this.projectId + '/databases/' + this.databaseId])
                        .catch(err => this.messagesService.errorToast(err));
                }, err => this.messagesService.errorToast(err)
            )
        ;
    }
}
